export default __webpack_public_path__ + "static/media/3_1_1.abd9434f.png";